import { profileDashboardCommands } from '../../shared/constants/profile-home-route.util';

/** Profile fields needed for consult-shell routing (slug may be missing on home-nav shapes). */
export type ConsultProfileRouteLike = {
  slug?: string | null;
  profile_category?: string | null;
  source_store_code?: string | null;
};

/** Non-student public profiles can use the business-consult shell. */
export function isConsultEligibleProfile(
  profile: Pick<ConsultProfileRouteLike, 'slug' | 'profile_category'> | null | undefined
): boolean {
  const slug = String(profile?.slug || '').trim();
  if (!slug) return false;
  const cat = String(profile?.profile_category || '').trim().toLowerCase();
  return cat !== 'student';
}

/**
 * Store-code key for `/mybusiness-consult/:code`.
 * Prefer linked Vyasa store; otherwise use the profile slug (profile-only accounts).
 */
export function consultDashboardCodeForProfile(
  profile: Pick<ConsultProfileRouteLike, 'slug' | 'source_store_code'> | null | undefined
): string {
  const linked = String(profile?.source_store_code || '').trim();
  if (linked) return linked;
  return String(profile?.slug || '').trim();
}

/** Route into business-consult shell for an owned consultancy-style profile. */
export function consultDashboardRouteForProfile(
  profile: ConsultProfileRouteLike | null | undefined
): string[] | null {
  if (!isConsultEligibleProfile(profile)) return null;
  const code = consultDashboardCodeForProfile(profile);
  if (!code) return null;
  return profileDashboardCommands(code);
}
